import { useCallback } from "react";
import { SymbolIcon, TriggerButton } from "widgets";

import { type GenomeViewerStore, useGenomeViewerStore } from "../../../store/store.ts";
import type { Range } from "../../../types.ts";
import { getTrackOffsetY } from "../../../utils/graphics/track-offset.ts";

export const SelectRangeButton = ({
  range,
  trackGroupId,
  trackId,
  onClose,
}: {
  range: Range;
  trackGroupId: string;
  trackId: string;
  onClose: () => void;
}) => {
  const trackGroups = useGenomeViewerStore((state) => state.trackGroups);
  const postTrackSelectionMessages = useGenomeViewerStore((state) => state.postTrackSelectionMessages);
  const tracks = useGenomeViewerStore((state) => state.tracks);
  const fullRangeSelection = useGenomeViewerStore((state) => state.fullRangeSelection);

  const handleClick = useCallback(() => {
    const storeUpdate: Partial<GenomeViewerStore> = {};
    const trackGroupsInSelection = fullRangeSelection ? [...trackGroups.keys()] : [trackGroupId];
    const baseShift = trackGroups.get(trackGroupId)?.graphics.baseShift ?? 0;

    const offsetY = getTrackOffsetY(trackGroups, tracks, trackId);
    const start = baseShift + range.start - 1;
    const stop = baseShift + range.stop;

    // Update the selected range in the store
    storeUpdate.selectedRange = {
      start,
      stop,
      startY: offsetY,
      stopY: offsetY,
    };
    storeUpdate.trackGroupsInSelection = trackGroupsInSelection;
    useGenomeViewerStore.setState(storeUpdate);

    // Send selection message to the concerned track workers
    postTrackSelectionMessages(trackGroupsInSelection, {
      start,
      stop,
    });
    onClose();
  }, [
    fullRangeSelection,
    trackGroups,
    trackGroupId,
    tracks,
    trackId,
    range.start,
    range.stop,
    postTrackSelectionMessages,
    onClose,
  ]);

  return (
    <TriggerButton
      icon={
        <SymbolIcon
          icon={"expand"}
          style={{
            zIndex: 1,
            transform: "rotate(90deg)",
            transformOrigin: "center",
          }}
        />
      }
      onPress={handleClick}
      label={"Select Range"}
    />
  );
};
